import React, { useEffect, useState } from "react";
import "./App.css"
import { Routes, Route, useLocation } from "react-router-dom";
import { Home, CustomPackages, PackagesCategoriesList, PackagesList, PackageDetails, Login, ContactUs, CustomPackageDetails, Profile, AboutUs, PrivacyPolicy, ServicesList, HotelList,FlightList, Hotels, HotelDetailsPage, Flights,TermsConditions } from "./pages";
// import { Home, CustomPackages, PackagesCategoriesList, PackagesList, PackageDetails, Login, ContactUs, CustomPackageDetails, Profile, AboutUs, PrivacyPolicy, HotelList } from "./pages";
import { NavigationBar, Footer } from "./layouts";
import { Register, CheckEmail, ResetPassword, ForgetPassword, AddNewPassword } from "./Auth";
import { fetchPageData } from "./utils/apis/fetchPageData";
import { NotFound, SpinnerLoading } from "./components";
import AOS from "aos";
import "aos/dist/aos.css";
// import fav_logo from './assets/images/logo-favicon.png';
import Cookies from 'js-cookie';
import { GlobalProvider } from './contexts/GlobalContext';
 



function App() {


    // useEffect(() => {
    //     const updateFavicon = () => {
    //         let link = document.querySelector('link[rel="icon"]');
    //         if (!link) {
    //         link = document.createElement('link');
    //         link.rel = 'icon';
    //         document.head.appendChild(link);
    //         }
    //         link.href = fav_logo;
    //     };

    //     updateFavicon();
    // }, []);
    
    useEffect(() => {
        AOS.init({
            once: true,
        });
    }, []);

    const url = "https://viaggioerp.inter-netsys.com"

    const location = useLocation();
    const pageName = location.pathname.replace(/^\//, "") ? location.pathname.replace(/^\//, "") : "home";
    

 



    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(pageName === "home" || pageName.toLowerCase() === "packages" || pageName.toLowerCase() === "categories");
    const [error, setError] = useState(null);
    const Lang = Cookies.get("preferred_language") || "en";


    useEffect(() => {
        const getPageData = async () => {
            setLoading(true);
            const { data, error } = await fetchPageData(pageName);
            setPageData(data);
            setError(error);
            setLoading(false);
        };

        const query = new URLSearchParams(location.search);
        const hasFilters =
          !!query.get("search") ||
          !!query.get("category") ||
          !!query.get("destinations");

        if (
          pageName === "home" ||
          pageName.toLowerCase() === "about" ||
          pageName.toLowerCase() === "contact" ||
          pageName.toLowerCase() === "categories" ||
          pageName.toLowerCase() === "services" ||
          pageName.toLowerCase() === "privacy" ||
          pageName.toLowerCase() === "terms" ||
          (pageName.toLowerCase() === "packages" && !hasFilters)
        ) {
          getPageData();
        }

    }, [pageName, location.search,Cookies.get("preferred_language") ]);


async function getUserCountry() {
  console.log("Fetching GeoIP...");
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) throw new Error("GeoIP request failed");
    const data = await res.json();

    console.log("GeoIP Response:", data);
    return data;
  } catch (err) {
    console.error("Error fetching GeoIP:", err);
    // Return default data if fetch fails
    return { country_code: "US", preferred_currency: "USD", languages: "en" };
  }
}

useEffect(() => {
  if (!Cookies.get("country")) {
    const initGeoIP = async () => {
      const data = await getUserCountry();

      Cookies.set("country", data.country_code);
      Cookies.set("preferred_currency", data.currency);
      const preferredLang = data.languages.includes("ar") ? "ar" : "en";
      Cookies.set("preferred_language", preferredLang);
      

      console.log("Cookies set:", {
        country: data.country_code,
        preferred_currency: data.currency,
        language: preferredLang,
      });
    };

    initGeoIP(); 
  } else {
    console.log("Cookies already exist:", {
      country: Cookies.get("country"),
      preferred_currency: Cookies.get("preferred_currency"),
      language: Cookies.get("preferred_language"),
    });
  }
}, []);






    



    if (loading) return <div className='loading-container'>
        <SpinnerLoading />
    </div>;


    
    return (
      // className="App"
      <GlobalProvider>
              <div className={`App`}>
        <NavigationBar url={url} />
        <Routes>
          <Route
            index
            element={<Home pageData={pageData?.content} url={url} />}
          />

          <Route
            path="/home"
            element={<Home pageData={pageData?.content} url={url} />}
          />

          <Route
            path="/hotels"
            element={<HotelList pageData={pageData} url={url} />}
          />

          <Route
            path="/flights"
            element={<FlightList pageData={pageData} url={url} />}
          />

          <Route
            path="/about"
            element={<AboutUs pageData={pageData} url={url} />}
          />

          <Route
            path="/privacy"
            element={<PrivacyPolicy pageData={pageData} url={url} />}
          />

          <Route
            path="/terms"
            element={<TermsConditions pageData={pageData} url={url} />}
          />

          <Route
            path="/categories"
            element={
              <PackagesCategoriesList
                pageData={pageData}
                url={url}
                errorNotFound={error}
              />
            }
          />

          <Route
            path="/services"
            element={
              <ServicesList
                pageData={pageData}
                url={url}
                errorNotFound={error}
              />
            }
          />

          <Route
            path="/Packages"
            element={<PackagesList pageData={pageData} url={url} />}
          />

          <Route path="/hotel" element={<Hotels url={url} />} />
          <Route path="/flight" element={<Flights url={url} />} />

          <Route path="/myPackages" element={<CustomPackages url={url} />} />
          <Route
            path="/packages/:category"
            element={
              <PackagesList
                pageData={pageData}
                url={url}
                errorNotFound={error}
              />
            }
          />

          <Route path="/package/:id" element={<PackageDetails url={url} />} />

          <Route path="/hotels/:id" element={<HotelDetailsPage url={url} />} />
          <Route path="/login" element={<Login url={url} />} />
          <Route path="/register" element={<Register url={url} />} />
          <Route path="/checkemail" element={<CheckEmail url={url} />} />
          <Route
            path="/resetpassword/:email/:code"
            element={<ResetPassword url={url} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword url={url} />}
          />

          <Route
            path="/contact"
            element={<ContactUs url={url} pageData={pageData} />}
          />
          <Route path="/profile" element={<Profile url={url} />} />
          <Route
            path="/myPackages/:id"
            element={<CustomPackageDetails url={url} />}
          />
          <Route
            path="/newpassword/:email"
            element={<AddNewPassword url={url} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
      </GlobalProvider>

    );
}

export default App;
